







































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiFamily from '@/api/family'
import { toSubArray } from '@/utils/groupBy'
import ReadComposition from '@/components/administration/family/read/ReadComposition.vue'
import ReadAdresse from '@/components/administration/family/read/ReadAdresse.vue'
import ReadCommandes from '@/components/administration/family/read/ReadCommandes.vue'
import ReadCartes from '@/components/administration/family/read/ReadCartes.vue'
import { AloFamily, getDefaultAloFamily } from '@/models/alo/AloFamily'
import { directPayloadQuery } from '@/utils/api'
import {DashboardAdmin} from '@/router/pages'
import ReadInscription from '@/components/compte/read/ReadInscription.vue'  


@Component({
  name: 'ModifyFamily', 
  props: {
    familyId:Number
  },
  components: { ReadComposition,ReadAdresse,ReadCommandes,ReadCartes,ReadInscription},
})

export default class ModifyFamily extends Vue {
  familyId!: number
  private showError = false    
  private rightDrawer = false
  private loading = false
  private saving = false

  get family(){
    return this.$store.myGetters.familyDic[this.familyId] || getDefaultAloFamily()
  }

/*
  get defaultCrops(){
    return this.$store.myGetters.configuration.family.crops
  }
  get maxImages(){
    return this.$store.myGetters.configuration.family.maxImages
  }*/

  loadFamily() {    
    this.loading = true    
    this.$store.myActions.ADM_FAMILY_DETAIL_REQUEST(this.familyId).finally(() => {      
      this.loading = false
    })    
  }

  created(){
    this.$store.myActions.ADM_ACTIVITY_ENSURE();
    this.loadFamily()
  }  

  get arianeItems() {
    const arianeItems =  [
        DashboardAdmin,
        {
          text: 'Familles',
          disabled: false,  
          to: {name:'AdminFamily'},        
          exact:true
        }
      ]
    if(this.family) {
        arianeItems.push({
          text: this.family.libelle,
          disabled: true,             
          to: {name:''},                         
          exact:true
        })
    }
    return arianeItems;
  } 
/*
  onOrderChange(temPhotosIds:string) {
   this.saveImages(temPhotosIds,"Modification de l'ordre des images sauvegardé")
  }

  onImageAdded(temPhotosIds:string){
    this.saveImages(temPhotosIds,"Ajout image(s) sauvegardé")
  }

  onImageDeleted(temPhotosIds:string){
    this.saveImages(temPhotosIds,"Image supprimée")
  }  
  
  saveImages(temPhotosIds:string,message:string){
    this.saving = true
    const temUplPhoto = (temPhotosIds && temPhotosIds.length>0)?parseInt(temPhotosIds.split(',')[0]):0
    const modified = {...this.family,temPhotosIds,temUplPhoto}
    this.$store.myActions.ADM_FAMILY_SAVE_REQUEST(modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(message)                  
      }).finally(() => {
        this.saving = false
      })
  }
*/

}
